(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/player-login-react/assets/react/shared-components/iam-iframe-message-handler.js') >= 0) return;  svs.modules.push('/modules/player-login-react/assets/react/shared-components/iam-iframe-message-handler.js');

'use strict';

if (svs.accountservices.check_iam.isIamIFrameEnabled) {
  var _svs, _svs2, _svs3, _svs4;
  const {
    getReturnUrlForEidApp
  } = svs.playerLoginReact.sharedComponents.iamIframeEidAppHandler;
  const POST_MESSAGE_SOURCE = 'svs-iam-parent';
  const TARGET_ORIGIN = (_svs = svs) === null || _svs === void 0 || (_svs = _svs.playerLoginReact) === null || _svs === void 0 || (_svs = _svs.data) === null || _svs === void 0 || (_svs = _svs.origins) === null || _svs === void 0 ? void 0 : _svs.target;
  const TRUSTED_ORIGIN = (_svs2 = svs) === null || _svs2 === void 0 || (_svs2 = _svs2.playerLoginReact) === null || _svs2 === void 0 || (_svs2 = _svs2.data) === null || _svs2 === void 0 || (_svs2 = _svs2.origins) === null || _svs2 === void 0 ? void 0 : _svs2.trusted;
  const SAME_SITE_TARGET_ORIGIN = (_svs3 = svs) === null || _svs3 === void 0 || (_svs3 = _svs3.playerLoginReact) === null || _svs3 === void 0 || (_svs3 = _svs3.data) === null || _svs3 === void 0 || (_svs3 = _svs3.origins) === null || _svs3 === void 0 ? void 0 : _svs3.sameSiteTarget;
  const TRUSTED_REDIRECT_URLS = ((_svs4 = svs) === null || _svs4 === void 0 || (_svs4 = _svs4.playerLoginReact) === null || _svs4 === void 0 || (_svs4 = _svs4.data) === null || _svs4 === void 0 ? void 0 : _svs4.trustedRedirectUrls) || [];

  const POST_MESSAGE_TYPES = {
    HEIGHT: 'height',
    SHOW_DIALOG: 'show-dialog',
    SHOW_DIALOG_RESOLVED: 'show-dialog-resolved',
    SHOW_DIALOG_EXTENDED: 'show-dialog-extended',
    SHOW_DIALOG_EXTENDED_RESOLVED: 'show-dialog-extended-resolved',
    PARENT_REDIRECT: 'parent-redirect',
    GET_ONBOARDING_DATA: 'get-onboarding-data',
    FULLSCREEN: 'fullscreen',
    REMOVE_FULLSCREEN: 'remove-fullscreen',
    UPDATE_ONBOARDING_DATA: 'update-onboarding-data',
    SET_LOGIN_TYPE: 'set-login-type',
    UPDATE_PARENT_QUERYSTRING: 'update-parent-querystring',
    PARENT_QUERYSTRING_UPDATED: 'parent-querystring-updated',
    PARENT_ONBOARDING_DATA_UPDATED: 'parent-onboarding-data-updated',
    PARENT_TRACK_EVENT: 'parent-track-event',
    PARENT_TRACK_EVENT_RESOLVED: 'parent-track-event-resolved'
  };
  const {
    showDialog,
    showDialogExtended
  } = svs.playerLoginReact.sharedComponents.Dialogs;
  const isTrustedRedirectUrl = url =>
  TRUSTED_REDIRECT_URLS.some(trustedRedirectUrl => url.startsWith(trustedRedirectUrl));
  window.addEventListener('message', async event => {
    var _event$data;
    if (event.origin !== TRUSTED_ORIGIN && event.origin !== window.location.origin) {
      return; 
    }
    const iframe = document.getElementById('iamlogin-iframe');
    if ((event === null || event === void 0 || (_event$data = event.data) === null || _event$data === void 0 ? void 0 : _event$data.source) === 'svs-iam-iframe') {
      var _event$data2, _event$data5, _event$data0, _event$data16, _event$data20, _event$data21, _event$data22, _event$data23, _event$data24, _event$data27, _event$data29, _event$data30, _event$data32;
      if ((event === null || event === void 0 || (_event$data2 = event.data) === null || _event$data2 === void 0 ? void 0 : _event$data2.messageType) === POST_MESSAGE_TYPES.HEIGHT) {
        if (!iframe.classList.contains('iamlogin-iframe-fullscreen')) {
          var _event$data3, _event$data4;
          iframe.style.height = (_event$data3 = event.data) !== null && _event$data3 !== void 0 && _event$data3.value ? "".concat((_event$data4 = event.data) === null || _event$data4 === void 0 ? void 0 : _event$data4.value, "px") : 'auto';
        }
      } else if ((event === null || event === void 0 || (_event$data5 = event.data) === null || _event$data5 === void 0 ? void 0 : _event$data5.messageType) === POST_MESSAGE_TYPES.SHOW_DIALOG) {
        var _event$data6, _event$data7, _event$data8, _event$data9;
        await showDialog((_event$data6 = event.data) === null || _event$data6 === void 0 || (_event$data6 = _event$data6.value) === null || _event$data6 === void 0 ? void 0 : _event$data6.title, (_event$data7 = event.data) === null || _event$data7 === void 0 || (_event$data7 = _event$data7.value) === null || _event$data7 === void 0 ? void 0 : _event$data7.errorMessage);
        const targetOrigin = (_event$data8 = event.data) !== null && _event$data8 !== void 0 && _event$data8.sameSiteTarget ? SAME_SITE_TARGET_ORIGIN : TARGET_ORIGIN;
        iframe.contentWindow.postMessage({
          source: POST_MESSAGE_SOURCE,
          messageType: POST_MESSAGE_TYPES.SHOW_DIALOG_RESOLVED
        }, targetOrigin);
        if ((_event$data9 = event.data) !== null && _event$data9 !== void 0 && (_event$data9 = _event$data9.value) !== null && _event$data9 !== void 0 && _event$data9.redirectUrl) {
          svs.utils.url.navigate(svs.utils.url.makeInternal(event.data.value.redirectUrl, svs.core.urlMapping.get('startPage')));
        }
      } else if ((event === null || event === void 0 || (_event$data0 = event.data) === null || _event$data0 === void 0 ? void 0 : _event$data0.messageType) === POST_MESSAGE_TYPES.SHOW_DIALOG_EXTENDED) {
        var _event$data1, _event$data10, _event$data11, _event$data12, _event$data13, _event$data14, _event$data15;
        const resolvedValue = await showDialogExtended((_event$data1 = event.data) === null || _event$data1 === void 0 || (_event$data1 = _event$data1.value) === null || _event$data1 === void 0 ? void 0 : _event$data1.title, (_event$data10 = event.data) === null || _event$data10 === void 0 || (_event$data10 = _event$data10.value) === null || _event$data10 === void 0 ? void 0 : _event$data10.message, (_event$data11 = event.data) === null || _event$data11 === void 0 || (_event$data11 = _event$data11.value) === null || _event$data11 === void 0 ? void 0 : _event$data11.icon, (_event$data12 = event.data) === null || _event$data12 === void 0 || (_event$data12 = _event$data12.value) === null || _event$data12 === void 0 ? void 0 : _event$data12.type, (_event$data13 = event.data) === null || _event$data13 === void 0 || (_event$data13 = _event$data13.value) === null || _event$data13 === void 0 ? void 0 : _event$data13.actions);
        const targetOrigin = (_event$data14 = event.data) !== null && _event$data14 !== void 0 && _event$data14.sameSiteTarget ? SAME_SITE_TARGET_ORIGIN : TARGET_ORIGIN;
        iframe.contentWindow.postMessage({
          source: POST_MESSAGE_SOURCE,
          messageType: POST_MESSAGE_TYPES.SHOW_DIALOG_EXTENDED_RESOLVED,
          resolvedValue
        }, targetOrigin);
        if ((_event$data15 = event.data) !== null && _event$data15 !== void 0 && (_event$data15 = _event$data15.value) !== null && _event$data15 !== void 0 && _event$data15.redirectUrl) {
          svs.utils.url.navigate(svs.utils.url.makeInternal(event.data.value.redirectUrl, svs.core.urlMapping.get('startPage')));
        }
      } else if ((event === null || event === void 0 || (_event$data16 = event.data) === null || _event$data16 === void 0 ? void 0 : _event$data16.messageType) === POST_MESSAGE_TYPES.PARENT_REDIRECT) {
        var _event$data17;
        if (isTrustedRedirectUrl((_event$data17 = event.data) === null || _event$data17 === void 0 ? void 0 : _event$data17.value)) {
          var _event$data18;
          svs.utils.url.navigate((_event$data18 = event.data) === null || _event$data18 === void 0 ? void 0 : _event$data18.value);
        } else {
          var _event$data19;
          svs.utils.url.navigate(svs.utils.url.makeInternal((_event$data19 = event.data) === null || _event$data19 === void 0 ? void 0 : _event$data19.value, svs.core.urlMapping.get('startPage')));
        }
      } else if ((event === null || event === void 0 || (_event$data20 = event.data) === null || _event$data20 === void 0 ? void 0 : _event$data20.messageType) === POST_MESSAGE_TYPES.GET_ONBOARDING_DATA) {
        var _svs5, _extraData$branding, _extraData$branding$t;
        const extraData = await ((_svs5 = svs) === null || _svs5 === void 0 || (_svs5 = _svs5.accountservices) === null || _svs5 === void 0 || (_svs5 = _svs5.onboardingHandler) === null || _svs5 === void 0 ? void 0 : _svs5.getExtraData());
        const theme = svs.accountservices.onboardingHandler.getTheme((extraData === null || extraData === void 0 || (_extraData$branding = extraData.branding) === null || _extraData$branding === void 0 || (_extraData$branding$t = _extraData$branding.toLowerCase) === null || _extraData$branding$t === void 0 ? void 0 : _extraData$branding$t.call(_extraData$branding)) || '');
        const state = svs.playerLoginReact.storeRef.getState();
        const {
          cancelUrl,
          returnUrl,
          isReturnNewCustomer
        } = state.playerloginreact;
        iframe.contentWindow.postMessage({
          source: POST_MESSAGE_SOURCE,
          messageType: POST_MESSAGE_TYPES.GET_ONBOARDING_DATA,
          value: {
            extraData,
            cancelUrl,
            returnUrl,
            isReturnNewCustomer,
            theme,
            product: (theme === null || theme === void 0 ? void 0 : theme.branding) || 'tur-100'
          }
        }, TARGET_ORIGIN);
      } else if ((event === null || event === void 0 || (_event$data21 = event.data) === null || _event$data21 === void 0 ? void 0 : _event$data21.messageType) === POST_MESSAGE_TYPES.FULLSCREEN) {
        iframe.classList.add('iamlogin-iframe-fullscreen');
        iframe.style.height = '100%';
      } else if ((event === null || event === void 0 || (_event$data22 = event.data) === null || _event$data22 === void 0 ? void 0 : _event$data22.messageType) === POST_MESSAGE_TYPES.REMOVE_FULLSCREEN) {
        iframe.classList.remove('iamlogin-iframe-fullscreen');
        iframe.style.height = '';
      } else if ((event === null || event === void 0 || (_event$data23 = event.data) === null || _event$data23 === void 0 ? void 0 : _event$data23.messageType) === POST_MESSAGE_TYPES.UPDATE_ONBOARDING_DATA && (_event$data24 = event.data) !== null && _event$data24 !== void 0 && _event$data24.requestId) {
        var _event$data25, _event$data26;
        const updateOnboardingUrls = value => new Promise(resolve => {
          svs.core.deviceSession.set('onboardingUrls', 'customer_login', value, () => {
            resolve();
          });
        });
        const updatedOnboardingData = await svs.accountservices.onboardingHandler.updateExtraData({
          newExtraData: ((_event$data25 = event.data) === null || _event$data25 === void 0 || (_event$data25 = _event$data25.value) === null || _event$data25 === void 0 ? void 0 : _event$data25.onboardingData) || {}
        });
        await updateOnboardingUrls(((_event$data26 = event.data) === null || _event$data26 === void 0 || (_event$data26 = _event$data26.value) === null || _event$data26 === void 0 ? void 0 : _event$data26.onboardingUrls) || {});
        const response = {
          source: POST_MESSAGE_SOURCE,
          requestId: event.data.requestId,
          messageType: POST_MESSAGE_TYPES.PARENT_ONBOARDING_DATA_UPDATED,
          value: updatedOnboardingData
        };
        iframe.contentWindow.postMessage(response, TARGET_ORIGIN);
      } else if ((event === null || event === void 0 || (_event$data27 = event.data) === null || _event$data27 === void 0 ? void 0 : _event$data27.messageType) === POST_MESSAGE_TYPES.SET_LOGIN_TYPE) {
        var _event$data28;
        const setIamLoginType = value => new Promise(resolve => {
          svs.core.deviceSession.set('loginType', 'iam', value, () => {
            resolve();
          });
        });
        await setIamLoginType(((_event$data28 = event.data) === null || _event$data28 === void 0 ? void 0 : _event$data28.value) || 'BANKID');
      } else if ((event === null || event === void 0 || (_event$data29 = event.data) === null || _event$data29 === void 0 ? void 0 : _event$data29.messageType) === POST_MESSAGE_TYPES.UPDATE_PARENT_QUERYSTRING && (_event$data30 = event.data) !== null && _event$data30 !== void 0 && _event$data30.requestId) {
        var _event$data31;
        const {
          token,
          returnUrl,
          cancelUrl,
          returnNewCustomer,
          isBankId
        } = ((_event$data31 = event.data) === null || _event$data31 === void 0 ? void 0 : _event$data31.value) || {};
        const parentQuerystring = getReturnUrlForEidApp(token, returnUrl, cancelUrl, returnNewCustomer, isBankId);
        const response = {
          source: POST_MESSAGE_SOURCE,
          requestId: event.data.requestId,
          messageType: POST_MESSAGE_TYPES.PARENT_QUERYSTRING_UPDATED,
          value: parentQuerystring
        };
        iframe.contentWindow.postMessage(response, TARGET_ORIGIN);
      } else if ((event === null || event === void 0 || (_event$data32 = event.data) === null || _event$data32 === void 0 ? void 0 : _event$data32.messageType) === POST_MESSAGE_TYPES.PARENT_TRACK_EVENT) {
        var _event$data33;
        const asyncTrackEvent = value => new Promise(resolve => {
          svs.components.analytics.trackEvent(value, () => {
            resolve();
          });
        });
        await asyncTrackEvent(((_event$data33 = event.data) === null || _event$data33 === void 0 ? void 0 : _event$data33.value) || {});
        event.source.postMessage({
          source: POST_MESSAGE_SOURCE,
          messageType: POST_MESSAGE_TYPES.PARENT_TRACK_EVENT_RESOLVED
        }, event.origin);
      }
    }
  });
}

 })(window);